module.exports = __webpack_public_path__ + "assets/img/key-success-story-hero.361f93b9.webp";